import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
  SectionTitle,
  Label,
  CheckBoxInput,
  CheckBoxLabel,
  CheckBoxesGroup,
  CheckBoxesGroupItem,
  Indicator,
} from "../styles/form-styles";

const Benefits = ({ benefits, handleBenefits }) => (
  <Fragment>
    <SectionTitle>Benefits</SectionTitle>
    <Label benefits>Benefits</Label>
    <CheckBoxesGroup>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={0}
            checked={benefits.indexOf(0) > -1}
            value="Car"
            onChange={(e) => handleBenefits(e)}
          />
          Car
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={1}
            checked={benefits.indexOf(1) > -1}
            value="Pension"
            onChange={(e) => handleBenefits(e)}
          />
          Pension
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={2}
            checked={benefits.indexOf(2) > -1}
            value="Parking"
            onChange={(e) => handleBenefits(e)}
          />
          Parking
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={4}
            checked={benefits.indexOf(4) > -1}
            value="Commission"
            onChange={(e) => handleBenefits(e)}
          />
          Commission
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={5}
            checked={benefits.indexOf(5) > -1}
            value="Gym Membership"
            onChange={(e) => handleBenefits(e)}
          />
          Gym Membership
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={6}
            checked={benefits.indexOf(6) > -1}
            value="Healthcare/Dental"
            onChange={(e) => handleBenefits(e)}
          />
          Healthcare/Dental
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
      <CheckBoxesGroupItem>
        <CheckBoxLabel>
          <CheckBoxInput
            type="checkbox"
            name="benefit"
            id={7}
            checked={benefits.indexOf(7) > -1}
            value="Other"
            onChange={(e) => handleBenefits(e)}
          />
          Childcare
          <Indicator />
        </CheckBoxLabel>
      </CheckBoxesGroupItem>
    </CheckBoxesGroup>
  </Fragment>
);

Benefits.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleBenefits: PropTypes.func.isRequired,
};

export default Benefits;
